import React from "react";

const STATUS = {
  passed: ["PASS", "bg-emerald-100 text-emerald-800"],
  awaiting_grading: ["Awaiting grading", "bg-amber-100 text-amber-800"],
  in_progress: ["In progress", "bg-sky-100 text-sky-800"],
  failed_resit: ["Not yet passed", "bg-red-100 text-red-700"],
  needs_repayment: ["Not passed (resit needs payment)", "bg-red-100 text-red-700"],
  not_started: ["Not started", "bg-zinc-100 text-zinc-600"],
  no_exam: ["No exam", "bg-zinc-100 text-zinc-600"],
};

export const CohortTotals = ({ t }) => (
  <div className="grid grid-cols-2 sm:grid-cols-5 gap-2" data-testid="cohort-progress-totals">
    {[["Members", t.members], ["Signed in", t.activated], ["Sat exam", t.sat], ["Passed", t.passed], ["Certificates sent", t.certificates_sent]].map(([l, v]) => (
      <div key={l} className="rounded-xl border border-[var(--border-warm)] bg-white p-3">
        <div className="text-[11px] uppercase tracking-wider text-zinc-500">{l}</div>
        <div className="font-display text-2xl">{v}</div>
      </div>
    ))}
  </div>
);

export const CohortProgressTable = ({ rows, showEmail }) => (
  <div className="overflow-x-auto rounded-xl border border-[var(--border-warm)] bg-white" data-testid="cohort-progress-table">
    <table className="w-full text-sm min-w-[560px]">
      <thead className="bg-[var(--cream)] text-left text-xs uppercase tracking-wider text-zinc-600">
        <tr><th className="p-2.5">Member</th><th className="p-2.5">Country</th><th className="p-2.5">Signed in</th><th className="p-2.5">Exam</th><th className="p-2.5">Best score</th><th className="p-2.5">Certificate</th></tr>
      </thead>
      <tbody className="divide-y divide-[var(--border-warm)]">
        {rows.map((r, i) => {
          const [label, cls] = STATUS[r.exam_status] || STATUS.not_started;
          return (
            <tr key={r.user_id || i} data-testid={`cohort-progress-row-${i}`}>
              <td className="p-2.5"><div className="font-semibold">{r.name}</div>{showEmail && <div className="text-xs text-zinc-500 break-all">{r.email}</div>}</td>
              <td className="p-2.5">{r.country}</td>
              <td className="p-2.5">{r.activated ? "Yes" : "Not yet"}</td>
              <td className="p-2.5"><span className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ${cls}`}>{label}</span></td>
              <td className="p-2.5">{r.best_percent != null ? `${r.best_percent}%` : "-"}</td>
              <td className="p-2.5">{r.certificate_sent ? "Sent" : "-"}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
);
